<template>
    <header>
        <h1>Wenslijstje</h1>
        <p>van boeken</p>
    </header>
</template>

<script>
export default {
    name: "Header"
}
</script>

<style scoped>
 header {
    background-color : darkgreen;
    text-align : center;
    color:floralwhite
 } 
</style>